const MAP_INITIAL = {
  bbox: [-5.395, 41.123, 9.819, 51.304],
  initialCoordinates: { latitude: 46.2135, longitude: 2.212 },
  style: 'mapbox://styles/mapbox/streets-v11',
  zoom: 10,
};

export { MAP_INITIAL };
